<template>
  <div class="waterlogging" v-show="params.flag">
    <el-dialog
      title="降雨阈值"
      :visible.sync="dialogVisible"
      v-dialogDrag
      :modal="false"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :modal-append-to-body="false"
      ref="yjxhRef"
      :before-close="beforeClose"
    >
    <div class="name">
      <img src="@/assets/images/water_address.png" alt="">
      内涝隐患点名称：{{ pointData.waterName }}
    </div>
      <div class="station top1">
        <div class="item">等级</div>
        <div class="item">5分钟雨量</div>
        <div class="item">10分钟雨量</div>
        <div class="item">30分钟雨量</div>
        <div class="item">1小时雨量</div>
        <div class="item">2小时雨量</div>
        <div class="item">3小时雨量</div>
      </div>
      <div class="center" v-if="waterStandard.minut5">
         <div class="item-wrap " v-for="(item, index) in options3" :key="index">
          <div class="item">{{ item.label }}</div>
           <div class="item">{{ waterStandard.minut5[index] }}</div>
           <div class="item">{{ waterStandard.minut10[index] }}</div>
           <div class="item">{{ waterStandard.minut30[index] }}</div>
           <div class="item">{{ waterStandard.hour1[index] }}</div>
           <div class="item">{{ waterStandard.hour2[index] }}</div>
           <div class="item">{{ waterStandard.hour3[index] }}</div>
         </div>

      </div>
      <div id="waterlogging-echart" ref="waterloggingEchartRef"></div>
    </el-dialog>
    <div class="w-right">
      <div class="w-header">
        <div class="tabs">
          <div
            :class="{ tab: true, active: currentIndex === index }"
            v-for="(item, index) in waterlogTypes"
            :key="index"
          >
            <div class="name" @click="changeWaterlogType(index)">
              {{ item }}
            </div>
          </div>
        </div>
        <div class="p-time">{{ pTime?$moment(pTime).format('YYYY年MM月DD日 HH时mm分'):'' }}</div>
        <div class="close" @click="() => params.flag && $parent.toggleProductView(params.productInfo.code)">
          <img src="../assets//images/关闭.png" alt="" />
        </div>
      </div>
      <div class="search-box">
        <div class="search-item" v-show="currentIndex === 0">
          <div class="label">行政区域</div>
          <el-select v-model="searchObj.county" placeholder="请选择" class="water-select">
            <el-option
              v-for="item in options1"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="search-item" v-show="currentIndex === 0">
          <div class="label">名&ensp;&ensp;&ensp;&ensp;称</div>
          <el-input
            v-model="searchObj.waterName"
            placeholder="请输入内容"
          ></el-input>
          <!-- <el-select v-model="searchObj.waterName" placeholder="请选择">
            <el-option
              v-for="item in options2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
        </div>
        <div class="search-item">
          <div class="label">内涝等级</div>
          <el-select v-model="searchObj.waterGrade" placeholder="请选择">
            <el-option
              v-for="item in options3"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="search-item" v-show="currentIndex === 0">
          <div class="label">易发程度</div>
          <el-select v-model="searchObj.riskLevel" placeholder="请选择">
            <el-option
              v-for="item in options4"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div class="btn" @click="filterData" v-if="currentIndex === 1">
          查询
        </div>
      </div>
      <div class="btn-box" v-if="currentIndex === 0">
        <!-- <div class="btn">导出列表</div> -->
        <div class="btn" @click="filterData">查询</div>
      </div>
      <div class="list-box">
        <div
          class="list-header row-item"
          :class="{ 'two-head': currentIndex === 1 }"
        >
          <span
            class="item"
            v-for="(item, index) in currentIndex === 0
              ? headerData1
              : headerData2"
            :key="index"
            >{{ item }}</span
          >
        </div>
        <div class="list-body" >
          <div class="row-item" v-for="(item, index) in bodyData" :key="index" >
            <div class="item" v-if="currentIndex === 0">{{ item.county }}</div>
            <div class="item" v-if="currentIndex === 0">
              {{ item.waterName }}
            </div>
            <div class="item" v-if="currentIndex === 0">
              {{ item.waterGrade }}
            </div>
            <div class="item" v-if="currentIndex === 0">{{ item.rain1h }}</div>
            <div class="item" v-if="currentIndex === 0">{{ item.rain2h }}</div>
            <div class="item" v-if="currentIndex === 0">
              {{ item.riskLevel }}
            </div>
            <div class="item" v-if="currentIndex === 1" style="flex: 2">
              {{ item.dataTime }}
            </div>
            <div class="item" v-if="currentIndex === 1" style="flex: 1">
              {{ item.waterGrade }}
            </div>
            <div class="item" v-if="currentIndex === 1" style="flex: 3">
              {{ item.dataSource }}
            </div>
          </div>

          <div class="no-data" v-show="bodyData.length===0">无数据</div>
        </div>
      </div>
    </div>

    <div class="tuli-box">
      <div class="name">内涝<br />等级</div>
      <div class="right">
        <div class="item" v-for="(item, index) in levelData" :key="index">
          <div class="top" @click="changeLeftBottomLeve(item.value)">
            <img
              :src="
                require(`@/assets/images/${
                  selectLevel.includes(item.value) ? '已选择' : '未选择'
                }.png`)
              "
              alt=""
            />
            <span>{{ item.value }}&ensp;级</span>
          </div>
          <div class="line" :style="{ background: item.color }"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Point } from 'ol/geom'
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import Feature from 'ol/Feature'
import { Icon, Style, Stroke, Fill } from 'ol/style'
import { apiData } from '../api/index'
import echarts from '@/config/echarts'
import { getWaterloggingOption } from '@/config/echarts/option/waterlogging'
export default {
  props: ['params'],
  data () {
    return {
      myEchart: null,
      headerData1: [
        '行政区域',
        '名称',
        '内涝等级',
        '1h雨量(mm)',
        '2h雨量(mm)',
        '易发程度'
      ],
      dialogVisible: false,
      bodyData: [
        {
          val1: '南沙区',
          val2: '广汽丰田',
          val3: 'III',
          val4: '21.5',
          val5: '21.5',
          val6: '低易发'
        },
        {
          val1: '南沙区',
          val2: '广汽丰田',
          val3: 'III',
          val4: '21.5',
          val5: '21.5',
          val6: '低易发'
        },
        {
          val1: '南沙区',
          val2: '广汽丰田',
          val3: 'III',
          val4: '21.5',
          val5: '21.5',
          val6: '低易发'
        },
        {
          val1: '南沙区',
          val2: '广汽丰田',
          val3: 'III',
          val4: '21.5',
          val5: '21.5',
          val6: '低易发'
        },
        {
          val1: '南沙区',
          val2: '广汽丰田',
          val3: 'III',
          val4: '21.5',
          val5: '21.5',
          val6: '低易发'
        }
      ],
      selectLevel: ['I', 'II', 'III', 'IV'],
      levelData: [
        { value: 'I', color: ' #FF5656' },
        { value: 'II', color: '#FFA937' },
        { value: 'III', color: '#FEFF68' },
        { value: 'IV', color: '#5AA7FF' }
      ],
      searchObj: {
        county: '',
        waterName: '',
        waterGrade: '',
        riskLevel: ''
      },
      value: '',
      currentIndex: 0,
      waterlogTypes: ['内涝监测预警'],
      // options1: [
      //   { label: '全区', value: '全区' },
      //   { label: '荔湾区', value: '荔湾区' },
      //   { label: '越秀区', value: '越秀区' },
      //   { label: '海珠区', value: '海珠区' },
      //   { label: '天河区', value: '天河区' },
      //   { label: '白云区', value: '白云区' },
      //   { label: '黄埔区', value: '黄埔区' },
      //   { label: '番禺区', value: '番禺区' },
      //   { label: '花都区', value: '花都区' },
      //   { label: '萝岗区', value: '萝岗区' },
      //   { label: '南沙区', value: '南沙区' },
      //   { label: '增城区', value: '增城区' },
      //   { label: '从化区', value: '从化区' }
      // ],
      options1: [{ label: '全区', value: '全区' },
        { label: '禅城区', value: '禅城区' },
        { label: '南海区', value: '南海区' },
        { label: '顺德区', value: '顺德区' },
        { label: '三水区', value: '三水区' },
        { label: '高明区', value: '高明区' }],
      activeFeature: '',
      options2: [],
      options3: [
        { label: 'I', value: 'I' },
        { label: 'II', value: 'II' },
        { label: 'III', value: 'III' },
        { label: 'IV', value: 'IV' }
      ],
      options4: [
        { label: '高易发', value: '高易发' },
        { label: '较高易发', value: '较高易发' },
        { label: '中易发', value: '中易发' },
        { label: '低易发', value: '低易发' }
      ],
      iconSource: null,
      iconlayer: null,
      totalData1: [],
      pointData: {},
      waterStandard: {},
      waterPointStandard: [],
      allFeatureIcon: [],
      pTime: ''

    }
  },
  watch: {
    'params.flag': {
      handler (flag) {
        if (flag) {
          this.$nextTick(() => {
            if (this.iconlayer) {
              this.iconlayer.setVisible(true)
            } else {
              this.queryWaterLiveGradeData()
            }
          })
        } else {
          this.dialogVisible = false
          this.addWaterLayer()
          this.activeFeature = ''
          this.iconlayer && this.iconlayer.setVisible(false)
        }
      },
      immediate: true
    }
  },
  created () {},
  computed: {},
  mounted () {
    this.$nextTick(() => {
      // this.queryWaterLiveGradeData()
      // this.initEchart()
    })
  },
  methods: {
    // 初始化echart
    initEchart () {
      if (!this.myEchart) {
        const dom = document.getElementById('waterlogging-echart')
        this.myEchart = echarts.init(dom)
      }
      const options = getWaterloggingOption()
      this.myEchart.setOption(options)
    },

    changeLeftBottomLeve (level) {
      const index = this.selectLevel.findIndex((item) => item === level)
      if (index > -1) {
        this.selectLevel.splice(index, 1)
      } else {
        this.selectLevel.push(level)
      }
      this.addWaterLayer()
    },

    async queryWaterLiveGradeData () {
      const result = await apiData.queryWaterLiveGradeData()
      const result1 = await apiData.queryWaterPointStandardData()
      if (!result.data) {
        this.totalData1 = []
        this.pTime = ''
      } else {
        this.totalData1 = result.data
        this.pTime = result.datatime
      }

      this.waterPointStandard = result1
      this.totalData1.map((item) => {
        item.waterGrade =
          item.waterGrade === 1
            ? 'I'
            : item.waterGrade === 2
              ? 'II'
              : item.waterGrade === 3
                ? 'III'
                : 'IV'
        item.riskLevel =
          item.riskLevel === 1
            ? '低易发'
            : item.riskLevel === 2
              ? '中易发'
              : item.riskLevel === 3
                ? '较高易发'
                : '高易发'
      })

      this.totalData1.forEach((item) => {
        this.options2.push({ label: item.waterName, value: item.waterName })
      })
      this.filterData()
      this.addWaterLayer()
    },

    filterData () {
      if (this.currentIndex === 0) {
        this.bodyData = this.totalData1.filter((item) => {
          if (
            (!this.searchObj.waterGrade ||
              item.waterGrade === this.searchObj.waterGrade) &&
            item.riskLevel.includes(this.searchObj.riskLevel) &&
            item.waterName.includes(this.searchObj.waterName) &&
            (item.county.includes(this.searchObj.county) || this.searchObj.county === '全区')
          ) {
            return true
          }
        })
      } else {
        this.bodyData = this.totalData2.filter((item) => {
          if (
            !this.searchObj.waterGrade ||
            item.waterGrade === this.searchObj.waterGrade
          ) {
            return true
          }
        })
      }

      this.searchObj.county = ''
      this.searchObj.waterGrade = ''
      this.searchObj.riskLevel = ''
      this.searchObj.waterName = ''
    },

    // 添加layer
    addWaterLayer () {
      if (!this.iconlayer) {
        this.iconSource = new VectorSource()
        this.iconlayer = new VectorLayer({
          zIndex: 9999,
          source: this.iconSource
        })
        this.params.map2d.map.addLayer(this.iconlayer)
      }
      this.iconSource && this.iconSource.clear()
      const features = []
      this.allFeatureIcon = []
      this.totalData1.forEach((item, index) => {
        if (!this.selectLevel.includes(item.waterGrade)) {
          return
        }
        if (index === 0) {
          this.activeFeature = item.target
        }
        const iconFeature = new Feature({
          geometry: new Point([item.lon, item.lat]),
          // name: 'feature',
          point: item
        })
        iconFeature.setStyle(
          new Style({
            image: new Icon({
              src: require(`@/assets/images/${item.waterGrade}.png`),
              // size: [20, 30],
              scale: 1
            })
          })
        )
        this.allFeatureIcon.push(iconFeature)
        iconFeature.on('singleclick', (item) => {
          if (this.activeFeature) {
            this.activeFeature.setStyle(
              new Style({
                image: new Icon({
                  src: require(`@/assets/images/${this.pointData.waterGrade}.png`),
                  scale: 1
                })
              })
            )
          }

          this.pointData = item.target.values_.point
          const id = this.pointData.waterId
          this.waterStandard = this.waterPointStandard[id]
          this.dialogVisible = true
          item.target.setStyle(
            new Style({
              image: new Icon({
                src: require(`@/assets/images/${this.pointData.waterGrade}-选中.png`),
                scale: 1
              })
            })
          )
          this.activeFeature = item.target
          this.iconSource.changed()
        })

        features.push(iconFeature)
      })

      this.iconSource.addFeatures(features)
      this.iconSource.changed()
    },

    changeWaterlogType (index) {
      this.currentIndex = index
      this.filterData()
    },

    beforeClose () {
      this.dialogVisible = false
    },
    // 设置弹出框的zIndex
    setZindex () {
      // this.$nextTick(() => {
      //   const el = this.$refs.yjxhRef
      //   let zIndex = JSON.parse(localStorage.getItem('dialogZIndex'))
      //   zIndex = zIndex * 1 + 1
      //   el.$el.style.zIndex = zIndex
      //   localStorage.setItem('dialogZIndex', JSON.stringify(zIndex))
      // })
    }
  }
}
</script>
<style lang="less" scoped>
.waterlogging {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;

  .tuli-box {
    display: flex;
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 1.2vw 0 0 0.63vw;
    background: url("../assets/images/water_bg.png") no-repeat;
    background-position: right top;
    color: #ffffff;
    height: 3.44vw;
    font-size: 0.73vw;
    color: #ffffff;
    line-height: 1.04vw;
    pointer-events: auto;
    //  .name{
    //     font-size: 14px;
    //     color: #FFFFFF;
    //     line-height: 20px;

    //   }
    .right {
      display: flex;
      margin: 0 1.93vw 0 1.51vw;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 3.54vw;
        .top {
          display: flex;
          align-items: center;
          cursor: pointer;
          img {
            margin-right: 0.31vw;
          }
        }

        .line {
          width: 3.54vw;
          height: 0.36vw;
          margin-top: 0.57vw;
          background: #ff5656;
        }
      }
    }
  }

  .name{
    display: flex;
    align-items: center;
    margin-bottom: 0.94vw;
    font-size: 0.73vw;
    font-weight: 600;
    color: #85D2FF;
    line-height: 1.04vw;
    img{
      width: 0.83vw;
      margin-right: 0.57vw;
    }
  }

  .item-wrap,.top1{
    display: flex;
     height: 2.76vw;
    line-height: 2.76vw;
    text-align: center;
    // padding: 0 1.46vw;

    color: #ffffff;
    font-size: 0.73vw;
    .item{
      flex: 1;
    }
  }

  .top1{
      background: #0b4170;
  }

  .item-wrap{
    border-bottom: 1px solid rgba(238,238,238,0.2);
  }

  // .top {
  //   display: flex;
  //   height: 2.76vw;
  //   line-height: 2.76vw;
  //   padding: 0 1.46vw;
  //   background: #0b4170;
  //   color: #ffffff;
  //   font-size: 0.73vw;
  //   .item:nth-child(1) {
  //     width: 5.16vw;
  //     font-weight: 600;
  //   }
  // }
  .center {
    // display: flex;
    margin-bottom: 0.99vw;
    background: transparent;
    border-bottom: 0.05vw solid rgba(238, 238, 238, 0.2);
  }

  #waterlogging-echart {
    flex: 1;
  }

  .w-right {
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 1.15vw;
    top: 16.8vh;
    width: 23.59vw;
    height: 74vh;
    z-index: 9999;
    background: #0d4270;
    border-radius: 0.63vw;
    opacity: 0.9;
    border: 0.05vw solid rgba(255, 255, 255, 0.5);
    pointer-events: auto;

    .w-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      .p-time{
        position: absolute;
        right: 2.6vw;
        margin-bottom: 0.52vw;
        font-size: 0.73vw;
        color: #fff;
      }
      .close {
        width: 0.63vw;
        margin-bottom: 0.52vw;
        margin-right: 1.04vw;
      }
      .close:hover {
        transform: scale(1.2);
        cursor: pointer;
      }
      .tabs {
        display: flex;
        align-items: center;
        flex: 1;
        height: 3vw;
        background: url("../assets/images/小标题样式.png") no-repeat;
        background-position: left bottom;
        .tab {
          display: flex;
          align-item: center;
          margin-left: 1.3vw;
          height: 2.08vw;
          color: rgba(255, 255, 255, 0.5);
          cursor: pointer;
        }
        .tab.active {
          color: #fff;
          .name {
            flex-shrink: 0;
            &::before {
              position: relative;
              top: 0.1vw;
              display: inline-block;
              content: "";
              width: 0.68vw;
              height: 0.89vw;
              margin-right: 0.36vw;
              background: url("../assets/images/星.png") no-repeat;
              background-size: 100%;
            }
          }
        }
      }
    }
    .search-box {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 0.83vw;
      padding: 0 0.63vw 0 0.94vw;
      .search-item {
        display: flex;
        align-items: center;
        width: calc((100% - 2.08vw) / 2);
        margin-bottom: 0.63vw;
        .label {
          margin-right: 0.42vw;
          font-size: 0.73vw;
          color: #ffffff;
        }
        /deep/ .el-input {
          flex: 1;
          border-radius: 0.21vw;
          border: 0.05vw solid #efefef;
        }
        /deep/ .el-select {
          flex: 1;
          border-radius: 0.21vw;
          // border: 0.05vw solid #efefef;
        }
        /deep/ .el-input__inner {
          height: 1.82vw;
          color: #fff;
          font-size: 0.73vw;
          background: transparent;
        }
      }
    }

    .btn-box {
      display: flex;
      justify-content: flex-end;
      padding-right: 0.52vw;
      .btn {
        width: 4.04vw;
        height: 1.5vw;
        margin: 0.42vw 0.26vw 0.94vw;
        text-align: center;
        line-height: 1.5vw;
        font-size: 0.83vw;
        font-weight: 600;
        color: #85d2ff;
        cursor: pointer;
        background: linear-gradient(
          135deg,
          rgba(106, 152, 199, 0.47) 0%,
          #36608f 51%,
          #3d6897 100%
        );
        border-radius: 0.26vw;
        border: 0.1vw solid;
        border-image: linear-gradient(
            135deg,
            rgba(112, 176, 247, 1),
            rgba(78, 133, 211, 0),
            rgba(112, 178, 250, 1)
          )
          2 2;
      }
    }
    .btn {
      width: 4.04vw;
      height: 1.5vw;
      margin: 0.42vw 0.26vw 0.94vw;
      text-align: center;
      line-height: 1.5vw;
      font-size: 0.83vw;
      font-weight: 600;
      color: #85d2ff;
      cursor: pointer;
      background: linear-gradient(
        135deg,
        rgba(106, 152, 199, 0.47) 0%,
        #36608f 51%,
        #3d6897 100%
      );
      border-radius: 0.26vw;
      border: 0.1vw solid;
      border-image: linear-gradient(
          135deg,
          rgba(112, 176, 247, 1),
          rgba(78, 133, 211, 0),
          rgba(112, 178, 250, 1)
        )
        2 2;
    }

    .list-box {
      display: flex;
      flex-direction: column;
      flex: 1;
      overflow: hidden;
      padding: 0vw 0.57vw 0.63vw 0.99vw;
      box-sizing: border-box;
      .list-header {
        display: flex;
        height: 3.02vw;
        background: #052c4d;
        font-weight: 600;
      }
      .two-head {
        .item:nth-child(1) {
          flex: 2;
        }
        .item:nth-child(2) {
          flex: 1;
        }
        .item:nth-child(3) {
          flex: 3;
        }
      }
      .list-body {
        flex: 1;
        overflow: hidden;
        overflow-y: auto;
        .row-item {
          display: flex;
          min-height: 2.6vw;
          border-bottom: 0.05vw solid rgba(246, 246, 255, 0.2);
        }
      }
      .list-body::-webkit-scrollbar {
        width: 0.42vw;
      }
      .list-body::-webkit-scrollbar-track {
        background: #e7e7e7;
        border-radius: 1.09vw;
      }
      .list-body::-webkit-scrollbar-thumb {
        background: #d8d8d8;
        border-radius: 1.09vw;
        height: 1.56vw;
      }

      .list-body::-webkit-scrollbar-track {
        background: #0c355f;
      }

      .item {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
        text-align: center;
        font-size: 0.73vw;
        line-height: 1.04vw;
        color: #ffffff;
      }
    }
  }

  /deep/.el-dialog__wrapper {
    pointer-events: none;
    .el-dialog__body{
      padding-top: 1.04vw;
    }
    .el-dialog {
      pointer-events: auto;
      width: 41.25vw;
      height: auto;
      margin-top: 20vh !important;
    }
  }
  .no-data{
    padding-top: 2.08vw ;
    font-size: .9vw;
    color: #FFF;
    text-align: center;
  }
}

</style>

<style>

 .el-scrollbar__view, .el-select-dropdown__item{
  background: #1d5a8f !important;
  color: #FFF;
  border: 0;
}

.el-select-dropdown__item:hover{
  background: #0b365b !important;
  color: #FFF;
}

.el-select-dropdown__item.active{
  background: #0b365b !important;
  color: #FFF;
}

/* // el-scrollbar__view */
</style>
